// // CategoryAdminPanel.js

// import React, { useState, useEffect } from 'react';
// import axios from 'axios';

// const CategoryAdminPanel = () => {
//   const [categories, setCategories] = useState([]);
//   const [newCategory, setNewCategory] = useState({ name: '', description: '' });

//   useEffect(() => {
//     fetchCategories();
//   }, []);

//   const fetchCategories = async () => {
//     try {
//       const response = await axios.get('http://localhost:4000/api/v1/course'); // Assuming your backend route for fetching categories is '/api/categories'
//       setCategories(response.data.data);
//     } catch (error) {
//       console.error('Error fetching categories:', error);
//     }
//   };

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setNewCategory({ ...newCategory, [name]: value });
//   };

//   const handleCreateCategory = async () => {
//     try {
//       const response = await axios.post('http://localhost:4000/api/v1/course', newCategory); // Assuming your backend route for creating categories is '/api/categories'
//       console.log(response.data);
//       setNewCategory({ name: '', description: '' });
//       fetchCategories(); // Refresh categories after creation
//     } catch (error) {
//       console.error('Error creating category:', error);
//     }
//   };

//   return (
//     <div>
//       <h1>Category Admin Panel</h1>
//       <div>
//         <h2>Create New Category</h2>
//         <input type="text" name="name" placeholder="Name" value={newCategory.name} onChange={handleInputChange} />
//         <input type="text" name="description" placeholder="Description" value={newCategory.description} onChange={handleInputChange} />
//         <button onClick={handleCreateCategory}>Create</button>
//       </div>
//       <div>
//         <h2>All Categories</h2>
//         <ul>
//           {categories.map(category => (
//             <li key={category._id}>
//               <div>Name: {category.name}</div>
//               <div>Description: {category.description}</div>
//             </li>
//           ))}
//         </ul>
//       </div>
//     </div>
//   );
// };

// export default CategoryAdminPanel;
// // CategoryAdminPanel.js

// import React, { useState, useEffect } from 'react';
// import axios from 'axios';

// const CategoryAdminPanel = () => {
//   const [categories, setCategories] = useState([]);
//   const [newCategory, setNewCategory] = useState({ name: '', description: '' });

//   useEffect(() => {
//     fetchCategories();
//   }, []);

//   const fetchCategories = async () => {
//     try {
//       const response = await axios.get('http://localhost:4000/api/v1/course'); // Assuming your backend route for fetching categories is '/api/categories'
//       setCategories(response.data.data);
//     } catch (error) {
//       console.error('Error fetching categories:', error);
//     }
//   };

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setNewCategory({ ...newCategory, [name]: value });
//   };

//   const handleCreateCategory = async () => {
//     try {
//       const response = await axios.post('http://localhost:4000/api/v1/course', newCategory); // Assuming your backend route for creating categories is '/api/categories'
//       console.log(response.data);
//       setNewCategory({ name: '', description: '' });
//       fetchCategories(); // Refresh categories after creation
//     } catch (error) {
//       console.error('Error creating category:', error);
//     }
//   };

//   return (
//     <div>
//       <h1>Category Admin Panel</h1>
//       <div>
//         <h2>Create New Category</h2>
//         <input type="text" name="name" placeholder="Name" value={newCategory.name} onChange={handleInputChange} />
//         <input type="text" name="description" placeholder="Description" value={newCategory.description} onChange={handleInputChange} />
//         <button onClick={handleCreateCategory}>Create</button>
//       </div>
//       <div>
//         <h2>All Categories</h2>
//         <ul>
//           {categories.map(category => (
//             <li key={category._id}>
//               <div>Name: {category.name}</div>
//               <div>Description: {category.description}</div>
//             </li>
//           ))}
//         </ul>
//       </div>
//     </div>
//   );
// };

// export default CategoryAdminPanel;


// import React from 'react'
// import { createCategory } from '../../../services/operations/courseDetailsAPI';
// import { useSelector } from 'react-redux';

// const CreateAdminPannel = () => {
//     const { token } = useSelector((state) => state.auth);
//     const [category, setCategory] = React.useState({
//         name: '',
//         description: ''
//     })


//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         if (!category.name || !category.description) {
//             return;
//         }
//         console.log(category);
//         const res = await createCategory({
//             name: category.name,
//             description: category.description
//         }, token);

//     }
//     return (
//         // create categories
//         <div className=' text-pure-greys-50 text-xl p-5'>
//             <form onSubmit={handleSubmit}>
//                 <div className='flex flex-col gap-2'>
//                     <label htmlFor="category">Category Name</label>
//                     <input value={category.name} onChange={
//                         (e) => setCategory({ ...category, name: e.target.value })
//                     } type="text" name="category" id="category" className="form-style" placeholder='Enter category name' />
//                 </div>
//                 <div className='flex flex-col gap-2 mt-10'>
//                     <label htmlFor="category">Category Description</label>
//                     <textarea value={category.description} onChange={
//                         (e) => setCategory({ ...category, description: e.target.value })
//                     } type="text" name="category" id="category" className="form-style" placeholder='Enter category description' />
//                 </div>
//                 <button type="submit" className=" mt-10 rounded-md bg-blue-50 px-6 py-3 text-center text-[13px] font-bold text-black shadow-[2px_2px_0px_0px_rgba(255,255,255,0.18)] transition-all duration-200 hover:scale-95 hover:shadow-none  disabled:bg-richblack-500 sm:text-[16px] ">Create</button>
//             </form>
//         </div>
//     )
// }

// export default CreateAdminPannel


import React from 'react';
import { createCategory, updateCategory, deleteCategory, getCategories } from '../../../services/operations/courseDetailsAPI';
import { useSelector } from 'react-redux';
import { useState, useEffect } from 'react';
import { toast } from 'react-hot-toast'; // Ensure toast notifications are set up
import VideoDetailsSidebar from '../ViewCourse/VideoDetailsSidebar';

const CreateAdminPannel = () => {
    const { token } = useSelector((state) => state.auth);
    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [category, setCategory] = useState({ name: '', description: '' });
    const [editMode, setEditMode] = useState(false);
    const [currentCategoryId, setCurrentCategoryId] = useState(null);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!category.name || !category.description) {
            return;
        }

        if (editMode) {
            const updatedSuccess = await updateCategory(currentCategoryId, category, token);
            if (updatedSuccess) {
                toast.success("Category updated successfully");
                fetchCategories(); // Refresh the category list
            }
        } else {
            const res = await createCategory(category, token);
            if (res) {
                toast.success("Category created successfully");
                fetchCategories(); // Refresh the category list
            }
        }

        // Reset the form
        resetForm();
    };

    const fetchCategories = async () => {
        setLoading(true);
        try {
            const fetchedCategories = await getCategories(token);
            setCategories(fetchedCategories);
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    const handleEdit = (category) => {
        setCategory({ name: category.name, description: category.description });
        setEditMode(true);
        setCurrentCategoryId(category._id);
    };

    const handleDelete = async (id) => {
        const confirmed = window.confirm("Are you sure you want to delete this category?");
        if (confirmed) {
            const deletedSuccess = await deleteCategory(id, token);
            if (deletedSuccess) {
                toast.success("Category deleted successfully");
                fetchCategories(); // Refresh the category list
            }
        }
    };

    const resetForm = () => {
        setCategory({ name: '', description: '' });
        setEditMode(false);
        setCurrentCategoryId(null);
    };

    useEffect(() => {
        fetchCategories();
    }, [token]);

    if (loading) return <div>Loading...</div>;
    if (error) return <div>Error: {error}</div>;

    return (
       <>
       
        <div className='text-pure-greys-500 text-xl p-5'>
            <form onSubmit={handleSubmit}>
                <div className='flex flex-col gap-2'>
                    <label htmlFor="category">Category Name</label>
                    <input
                        value={category.name}
                        onChange={(e) => setCategory({ ...category, name: e.target.value })}
                        type="text"
                        name="category"
                        id="category"
                        className="form-style"
                        placeholder='Enter category name'
                    />
                </div>
                <div className='flex flex-col gap-2 mt-10'>
                    <label htmlFor="category">Category Description</label>
                    <textarea
                        value={category.description}
                        onChange={(e) => setCategory({ ...category, description: e.target.value })}
                        name="category"
                        id="category"
                        className="form-style"
                        placeholder='Enter category description'
                    />
                </div>
                <div className="mt-10">
                    <button type="submit" className="rounded-md bg-blue-50 px-6 py-3 text-center text-[13px] font-bold text-black shadow-[2px_2px_0px_0px_rgba(255,255,255,0.18)] transition-all duration-200 hover:scale-95 hover:shadow-none disabled:bg-richblack-500 sm:text-[16px]">
                        {editMode ? "Update" : "Create"}
                    </button>
                    {editMode && (
                        <button
                            type="button"
                            onClick={resetForm}
                            className="ml-2 rounded-md bg-pure-greys-300 px-6 py-3 text-center text-[15px] font-bold text-black transition-all duration-200 hover:scale-95"
                        >
                            Cancel
                        </button>
                    )}
                </div>
            </form>

            <div className="text-pure-greys-500 p-5">
                <h2 className="text-2xl font-bold">All Categories</h2>
                <ul className="mt-5">
                    {categories.map((category) => (
                        <li key={category._id} className="bg-richblack-200 p-4 mb-2 rounded">
                            <h3 className="font-bold text-richblack-900">{category.name}</h3>
                            <p className='text-white'>{category.description}</p>
                            <div className="mt-2">
                                <button
                                    onClick={() => handleEdit(category)}
                                    className="mr-2 rounded-md bg-caribbeangreen-600 px-4 py-2 text-white"
                                >
                                    Edit
                                </button>
                                <button
                                    onClick={() => handleDelete(category._id)}
                                    className="rounded-md bg-pink-500 px-4 py-2 text-white"
                                >
                                    Delete
                                </button>
                            </div>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
       
       </>
    );
};

export default CreateAdminPannel;
